module.exports = __webpack_public_path__ + "489e4eddaec995806b5a578dd35abff4.svg";